import clsx from 'clsx';
import React, { useCallback } from 'react';
import { useStore } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import Avatar from '../../../base/avatar/components/Avatar';
import { translate } from '../../../base/i18n/functions';
import { withPixelLineHeight } from '../../../base/styles/functions.web';
import ListItem from '../../../base/ui/components/web/ListItem';
import { ACTION_TRIGGER, ACTIVE_CONNECTION, AudioStateIcons, ConnectionStateIcons, DEFAULT_MEETING_ROLE, DEFAULT_MEETING_STATE, MEDIA_STATE, MeetingRoleIcons, MeetingStateIcons, VideoStateIcons } from '../../constants';
import RaisedHandIndicator from './RaisedHandIndicator';
const useStyles = makeStyles()(theme => {
    return {
        nameContainer: {
            display: 'flex',
            flex: 1,
            overflow: 'hidden',
            fontSize: '0.875rem'
        },
        name: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        moderatorLabel: {
            ...withPixelLineHeight(theme.typography.labelBold),
            color: theme.palette.text03
        },
        avatar: {
            marginRight: theme.spacing(3)
        }
    };
});
/**
 * A component representing a participant entry in ParticipantPane and Lobby.
 *
 * @param {IProps} props - The props of the component.
 * @returns {ReactNode}
 */
function ParticipantItem({ actionsTrigger = ACTION_TRIGGER.HOVER, audioMediaState = MEDIA_STATE.NONE, children, disableModeratorIndicator, displayName, isHighlighted, isModerator, local, onLeave, openDrawerForParticipant, overflowDrawer, participantID, raisedHand, t, videoMediaState = MEDIA_STATE.NONE, youText, inLobby }) {
    const onClick = useCallback(() => openDrawerForParticipant?.({
        participantID,
        displayName
    }), []);
    const { classes } = useStyles();
    const meetingRole = DEFAULT_MEETING_ROLE;
    const icon = (React.createElement(Avatar, { className: classes.avatar, displayName: displayName, participantId: participantID, size: 32 }));
    // Reading roles of participant
    const store = useStore();
    const { conference } = store.getState()['features/base/conference'];
    const icRoles = conference?.getMemberICRoles(participantID);
    // Role cascading
    let mainRole = DEFAULT_MEETING_ROLE;
    if (isModerator) {
        mainRole = (icRoles && icRoles[0]?.name) || 'moderator';
    }
    else {
        mainRole = (icRoles && icRoles[0]?.name) || 'participant';
    }
    // Getting the role icon
    const roleIcon = MeetingRoleIcons[mainRole];
    const text = (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.nameContainer },
            inLobby && React.createElement("div", { className: clsx(classes.name, 'lobby-participant-name') }, displayName),
            !inLobby && React.createElement("div", { className: classes.name }, displayName),
            local ? React.createElement("span", null,
                "\u00A0(",
                youText,
                ")") : null,
            React.createElement("div", { className: 'LeftPlacedIcons' },
                ACTIVE_CONNECTION && ConnectionStateIcons,
                raisedHand && React.createElement(RaisedHandIndicator, { participantID: participantID })))));
    const indicators = (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'MiddlePlacedIcons' },
            VideoStateIcons[videoMediaState],
            AudioStateIcons[audioMediaState]),
        React.createElement("div", { className: 'RightPlacedIcons' },
            MeetingStateIcons[DEFAULT_MEETING_STATE],
            roleIcon)));
    return (React.createElement(ListItem, { actions: children, hideActions: local, icon: icon, id: `participant-item-${participantID}`, indicators: indicators, isHighlighted: isHighlighted, onClick: !local && overflowDrawer ? onClick : undefined, onMouseLeave: onLeave, textChildren: text, trigger: actionsTrigger }));
}
export default translate(ParticipantItem);
